import React from "react";

interface LStripeProviderProps {
  children: React.ReactNode;
}

// Web version - no Stripe provider needed since we redirect to Stripe Checkout
export const LStripeProvider = ({ children }: LStripeProviderProps) => {
  return <>{children}</>;
};
